import { render, staticRenderFns } from "./Shippings.vue?vue&type=template&id=43043991&scoped=true&"
import script from "./Shippings.vue?vue&type=script&lang=js&"
export * from "./Shippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43043991",
  null
  
)

export default component.exports